import { useEffect, useState } from 'react';
import './CalenderExportDialog.css';

export default function CalenderExportDialog({ calendar, onClose, onExport }) {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        if (calendar) {
            const today = new Date();
            const year = today.getFullYear();
            setStartDate(`${year}-01-01`);
            setEndDate(`${year}-12-31`);
        }
    }, [calendar]);

    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);
        if (endDate && newStartDate > endDate) {
            const nextDay = new Date(newStartDate);
            nextDay.setDate(nextDay.getDate() + 1);
            const formattedNextDay = nextDay.toISOString().split('T')[0];
            setEndDate(formattedNextDay);
        }
    };

    const handleExport = () => {
        if (!startDate || !endDate) {
            alert('Bitte wählen Sie Start- und Enddatum aus.');
            return;
        }
        onExport({ calendar, startDate, endDate });
    };

    return (
        <div className="calendar-export-dialog-backdrop" onClick={() => onClose(null)}>
            <div className="calendar-export-dialog" onClick={e => e.stopPropagation()}>
                <h2>Export: {calendar?.name}</h2>
                {!calendar && <p>Kein Kalender ausgewählt</p>}

                <div id="date-picker-container">
                    <div>
                        <label htmlFor="StartDatePicker">Startdatum</label>
                        <input
                            type="date"
                            id="StartDatePicker"
                            value={startDate}
                            onChange={handleStartDateChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="EndDatePicker">Enddatum</label>
                        <input
                            type="date"
                            id="EndDatePicker"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                </div>

                <button onClick={handleExport}>Exportieren</button>
            </div>
        </div>
    );
}
